<div class="dashboard-container">
  <div class="header-container">
    <span class="heading">Dashboard</span>
    <geaui-button-v3 [postIcon]="true">Take a tour</geaui-button-v3>
  </div>

  <div class="flex mt-5 gap-3">
    <div class="w-4">
      <app-dashboard-card [kpiData]="pendingProjects()" (titleSelected)="goToProjectsLastUpdated()"></app-dashboard-card>
    </div>
    <div class="w-4">
      <app-dashboard-card [kpiData]="completedProjects()" (titleSelected)="goToProjectsLastUpdated()"></app-dashboard-card>
    </div>
    <div class="w-4">
      <app-dashboard-products-card [topProductsKPIData]="topProducts" [isLoading]="isLoading"></app-dashboard-products-card>
    </div>
  </div>
  <div class="news-feed-wrapper">
    <div class="card">
      <div class="carousel-section product-info-section">
        <div class="gea-heading gea-font-heading-16">
          <span>GEA Heating and Refrigeration News </span>
          <span> | </span>
          <a (click)="openInNewTab('https://www.gea.com/en/')">GEA.com</a>
        </div>
        <p-carousel
          class="p-carousel-text"
          #productInfoCarousel
          [value]="productSlides"
          [numVisible]="1"
          [numScroll]="1"
          [circular]="true"
          showIndicators="false"
          showNavigators="false">
          <ng-template let-item pTemplate="item">
            <div class="product-info max-w-25rem">
              <div class="product-actual-info">
                <span class="product-name gea-font-heading-24">{{ item.title }}</span>
                <div class="product-details gea-font-body-16">
                  {{ item.text }}
                </div>
                <div class="read-more-btn">
                  <geaui-button-v3
                    class="btn-brdr-radius"
                    [type]="'primary'"
                    [postIcon]="true"
                    (click)="redirectToProduct(item.link)">
                    Read More
                  </geaui-button-v3>
                </div>
              </div>
            </div>
          </ng-template>
        </p-carousel>
      </div>
      <div class="carousel-section product-image-section">
        <div class="slider-nav">
          <span class="slider-count">{{ (imageCarousel?.page ?? 0) + 1 }}</span>
          @for (link of productSlides; track link; let i = $index) {
            <a
              [id]="'link-' + i"
              [ngClass]="i === (imageCarousel?.page || 0) ? 'is-active' : ''"
              [href]="'#feed-' + i"
              (click)="onSliderClick(i)"></a>
          }
        </div>
        <p-carousel
          class="p-carousel-image"
          #imageCarousel
          [value]="productSlides"
          [numVisible]="1"
          [numScroll]="1"
          [circular]="true"
          showIndicators="false"
          showNavigators="false">
          <ng-template let-item pTemplate="item">
            <img class="product-image" [src]="item.productImgSrc" alt="{{ item.altText }}" />
          </ng-template>
        </p-carousel>
        <div class="navigation-arrows">
          <div class="bubble" (click)="prevFeed()">
            <geaui-icon-v3 color="white" file="16px_arrow-left"></geaui-icon-v3>
          </div>
          <div class="bubble" (click)="nextFeed()">
            <geaui-icon-v3 color="white" file="16px_arrow-right"></geaui-icon-v3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
